import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      padding: '0',
    },
    subTableRow: {
      backgroundColor: '#d7d7d7',
    },
    filterColTop: {
      width: '100%',
    },
    inputFocused: {
      backgroundColor: 'white !important',
    },
    menuPaper: {
      maxHeight: 300,
    },
    tableContainer: {
      paddingTop: theme.spacing(1),
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      paddingLeft: 0,
      paddingRight: 0,
      overflowX: 'auto',
    },
    tableHeadContainer: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      overflowX: 'auto',
    },
    empty: {
      marginBottom: 20,
      marginTop: 20,
    },
    count: {
      fontStyle: 'bold',
      fontWeight: 600,
      color: '#000',
      marginRight: 15,
    },
    filterCol: {
      width: '100%',
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        width: 326,
      },
    },
    filter: {
      marginBottom: 5,
      padding: '25px 30px',
      overflow: 'visible',
    },
    label: {
      marginBottom: 7,
      fontSize: 14,
      fontWeight: 600,
      color: '#181c32',
    },
    rowFilter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    ordersCol: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 'calc(100% - 326px - 30px)',
        '&.full': {
          width: '100%',
        },
      },
    },
    orderColHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 30,
    },
    orderColHeaderItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    filterItem: {
      transition: '0.3s ease-out',

      '&.hide': {
        [theme.breakpoints.down('sm')]: {
          height: 0,
          transform: 'scaleY(0)',
          transformOrigin: 'top',
          overflow: 'hidden',
        },
      },
    },
    buttons: {
      marginRight: theme.spacing(3),
    },
    card: {
      // marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    bottomActions: {
      marginTop: theme.spacing(3),
    },
    img: {
      height: 70,
    },
    typeList: {
      backgroundColor: 'white',
      maxWidth: 200,
    },
    itemStatus: {
      borderRadius: '4px',
      backgroundColor: '#c9f7f5',
      flex: 1,
    },
    viewButton: {
      marginRight: theme.spacing(2),
      color: theme.palette.primary.dark,
      textTransform: 'none',
      boxShadow: 'none',
      borderRadius: 2,
      padding: '10px 35px',
      fontWeight: 700,
      background: '#EBECF0',

      '&:hover': {
        boxShadow: 'none',
      },
    },
    iconViewButton: {
      marginLeft: 10,
    },
    cell: {
      fontSize: 18,
    },
    cellItem: {
      fontSize: 14,
    },
    icon: {
      width: 22,
      height: 22,
    },
  })
);

export const useStylesOrderTable = makeStyles(theme =>
  createStyles({
    itemCard: {
      width: '97%',
      paddingLeft: 0,
      marginTop: 6,
      marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: 0,
      },
    },
    totalCard: {
      width: '97%',
      paddingLeft: 0,
      marginTop: 6,
      marginBottom: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: 20,
      },
    },
    img: {
      width: '50px',
      maxHeight: 65,
      cursor: 'pointer',
      borderRadius: 4,
      [theme.breakpoints.down('sm')]: {
        maxHeight: 80,
      },
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    infoWrapper: {
      marginLeft: 20,
      width: '100%',
      [theme.breakpoints.down(365)]: {
        marginLeft: 13,
      },
      [theme.breakpoints.down(350)]: {
        marginLeft: 4,
      },
    },
    infoButtonsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'start',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    link: {
      marginRight: theme.spacing(3),
      fontSize: 20,
      color: '#000000',
      fontWeight: 'normal',
      height: 32,
    },
    typeList: {
      backgroundColor: 'white',
      maxWidth: 200,
    },
    cardContent: {
      paddingLeft: 20,
      paddingTop: 25,
    },
    totalCardContent: {
      paddingLeft: 20,
      paddingTop: 25,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    totalRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    nameWrapper: {
      width: 250,
      overflow: 'hidden',
    },
    priceWrapper: {
      width: 200,
    },
    priceValue: {
      color: '#000000',
      fontSize: 21,
      height: 30,
      fontWeight: 'normal',
    },
    priceLabel: {
      color: '#000000',
      fontSize: 15,
      height: 20,
      fontWeight: 'normal',
    },
    countWrapper: {
      paddingLeft: 10,
      paddingRight: 10,
    },
    countValue: {
      // color: '#40271e',
      color: theme.palette.text.primary,
      fontSize: 20,
      height: 24,
      fontWeight: 'bold',
      paddingTop: 3,
    },
    sumValue: {
      // color: '#40271e',
      color: theme.palette.text.primary,
      fontSize: 21,
      height: 30,
      fontWeight: 'bold',
    },
    sumLabel: {
      color: '#000000',
      fontSize: 15,
      height: 32,
      fontWeight: 'normal',
    },
    totalLabel: {
      color: '#757575',
      fontSize: 21,
      height: 27,
      fontWeight: 'normal',
    },
    totalAmount: {
      color: '#000000',
      fontSize: 21,
      height: 27,
      fontWeight: 'bold',
      marginLeft: 10,
    },
    paymentStatus: {
      color: '#d01c1f',
      fontSize: 21,
      height: 27,
      fontWeight: 'bold',
      marginLeft: 10,
    },
    btnText: {
      fontSize: 20,
      color: '#ffffff',
      fontWeight: 'bold',
    },
  })
);

export const selectStylesOrdersList = {
    container: (provided: any) => ({
      ...provided,
      marginBottom: 16,
      width: '100%',
    }),
    menu: (provided: any, state: any) => ({
      ...provided,
      zIndex: 999,
      display: state.selectProps.isSearchable ? provided.display : 'none',
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderColor: state.isFocused ? '#d01c1f' : '',
      backgroundColor: '#f9f9f9',
      border: 'none !important',
      opacity: state.isDisabled ? 0.5 : 1,
      boxShadow: state.isFocused ? '0 0 0 1px #d01c1f !important' : '',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#d01c1f' : '#fff',
      color: state.isSelected ? '#fff' : '#000',
      ':hover': {
        backgroundColor: '#d01c1f',
        color: '#fff',
      },
      ':active': {
        backgroundColor: '#d01c1f',
        color: '#fff',
      },
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: '#4c4c4c',
      // fontFamily: '"PT Sans", serif',
      fontWeight: 600,
    }),
    placeholder: (provided: any) => ({
      ...provided,
      // fontFamily: '"PT Sans", serif',
      fontWeight: 600,
    }),
    dropdownIndicator: (provided: any, state: any) => {
      return {
        ...provided,
        display: state.selectProps.isSearchable ? provided.display : 'none',
      };
    },
  };